/* CT 2026-09-22 (v16) — Ficha de producto, comportamiento de la PRIMERA PANTALLA en MOVIL.
 *
 * Tres cosas, y nada mas:
 *   · el boton ATRAS,
 *   · el boton COMPARTIR (Web Share nativa, y si no existe copia el enlace y avisa),
 *   · el contador "1/4" de la galeria, que sigue al deslizar y al cambiar de color.
 *
 * 🔴 SOLO CORRE EN MOVIL. Sale enseguida si la pantalla es de 750px o mas, asi que en
 * escritorio no ejecuta nada.
 *
 * 🔴 CUIDADO CON EL INP: esta tienda tiene el INP en rojo en campo (257 ms) y el toque mas lento
 * es justo el de esta pagina. Por eso:
 *   · el listener de scroll es `passive` y solo agenda un requestAnimationFrame;
 *   · no se escribe en el DOM si el numero no cambio;
 *   · no hay ningun observer sobre la lista de fotos, que puede tener 100 imagenes.
 *
 * 🔴 LA GALERIA SE REEMPLAZA ENTERA AL CAMBIAR DE COLOR. Desde la sesion del 11-sep, elegir un
 * color pide el HTML al servidor y sustituye el <media-gallery>. Por eso el contador NO puede
 * quedarse con una referencia al <ul>: se vuelve a enganchar cuando el nodo cambia. Se observa
 * la ENVOLTURA (un solo nodo), no la lista.
 */
(() => {
  const MOVIL = window.matchMedia('(max-width: 749px)');
  if (!MOVIL.matches) return;

  const $ = s => document.querySelector(s);
  const ctrl = $('[data-ct-galeria-ctrl]');
  if (!ctrl) return;

  /* ---------------------------------------------------------------- atras */
  const atras = ctrl.querySelector('[data-ct-atras]');
  if (atras) {
    atras.addEventListener('click', () => {
      // Si la ficha se abrio directo (sin historia dentro del sitio), `history.back()` sacaria
      // al cliente de la tienda o no haria nada. En ese caso se lo manda al listado.
      if (window.history.length > 1 && document.referrer && document.referrer.includes(location.host)) {
        window.history.back();
      } else {
        window.location.href = '/collections/catalogo-de-telas-textiles-tejidos';
      }
    });
  }

  /* ------------------------------------------------------------ compartir */
  const compartir = ctrl.querySelector('[data-ct-compartir]');
  if (compartir) {
    compartir.addEventListener('click', async () => {
      const datos = { title: document.title.split('|')[0].trim(), url: location.href };
      try {
        if (navigator.share) { await navigator.share(datos); return; }
        await navigator.clipboard.writeText(location.href);
        aviso('Enlace copiado');
      } catch (e) {
        // `AbortError` es el usuario cerrando el menu de compartir: no es un fallo y no se avisa.
        if (e && e.name === 'AbortError') return;
        aviso('No se pudo compartir');
      }
    });
  }

  /* ----------------------------------------------------------------- lupa
   * Arriba del todo el encabezado esta escondido (v17), asi que la ficha se quedaba sin
   * buscador. Este boton NO abre un buscador propio: destapa el encabezado y pone el cursor en
   * EL MISMO campo que ya vive ahi (v19), para no duplicar la busqueda predictiva.
   *
   * 🔴 CT 2026-09-23 — DEJO DE FUNCIONAR, y no por el modal. Medido en el navegador: la lupa
   * ponia el foco en el campo, pero el encabezado seguia en y=-65 porque la regla que lo destapa
   * apuntaba a `.shopify-section-header`, clase que no existe (es el prefijo del ID). Arreglado
   * en snippets/ct-header-movil-critico.liquid. El respaldo por el modal se quito: desde la v19
   * el disparador del modal esta escondido en movil y el campo abierto existe siempre.
   *
   * 🔴 SE CIERRA AL TOCAR FUERA DEL ENCABEZADO, NO AL PERDER EL FOCO. Con `blur`, tocar un
   * resultado de la busqueda predictiva escondia el encabezado en el `mousedown`, antes del
   * clic, y el toque se perdia (en iOS un enlace no siempre recibe el foco). Por eso se escucha
   * `pointerdown` en la fase de captura y solo cierra si el toque cae FUERA del encabezado.
   * Tambien cierra con Escape.
   */
  const buscar = ctrl.querySelector('[data-ct-buscar]');
  if (buscar) {
    const raiz = document.documentElement;
    const cerrarBuscador = () => {
      raiz.classList.remove('ct-encabezado-forzado');
      document.removeEventListener('pointerdown', alTocarFuera, true);
      document.removeEventListener('keydown', alEscape, true);
      const c = document.querySelector('.ct-buscador-movil input[name="q"]');
      if (c && document.activeElement === c) c.blur();
    };
    function alTocarFuera(e) {
      const header = document.querySelector('.section-header');
      if (header && header.contains(e.target)) return;
      if (buscar.contains(e.target)) return;
      cerrarBuscador();
    }
    function alEscape(e) { if (e.key === 'Escape') cerrarBuscador(); }

    buscar.addEventListener('click', () => {
      const campo = document.querySelector('.ct-buscador-movil input[name="q"]');
      if (!campo) { window.location.href = '/search'; return; }
      if (raiz.classList.contains('ct-encabezado-forzado')) { cerrarBuscador(); return; }
      raiz.classList.add('ct-encabezado-forzado');
      // `preventScroll`: el encabezado ya esta arriba; sin esto algunos navegadores desplazan
      // la pagina para "mostrar" el campo y la foto se corre.
      campo.focus({ preventScroll: true });
      document.addEventListener('pointerdown', alTocarFuera, true);
      document.addEventListener('keydown', alEscape, true);
    });
  }

  let tiempoAviso = null;
  function aviso(texto) {
    let el = $('.ct-aviso');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ct-aviso';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = texto;
    el.classList.add('ct-aviso--visible');
    clearTimeout(tiempoAviso);
    tiempoAviso = setTimeout(() => el.classList.remove('ct-aviso--visible'), 2200);
  }

  /* ------------------------------------------------------------- contador */
  const salida = ctrl.querySelector('[data-ct-contador]');
  let lista = null, pendiente = false, ultimo = '';

  // "visible" se decide por si el navegador le dibuja alguna caja: cubre tanto las que el
  // tema esconde por variante como las que no se renderizan.
  const visibles = ul => [...ul.children].filter(li => li.getClientRects().length > 0);

  function pintar() {
    pendiente = false;
    if (!lista) return;
    const slides = visibles(lista);
    const total = slides.length;
    // Con una sola foto el contador no dice nada: se esconde. Y se le BORRA el texto, si no
    // queda el valor de la variante anterior ahi dentro, invisible pero legible desde fuera
    // (paso en la prueba: la galeria tenia 1 foto y el contador seguia diciendo "1/4").
    if (total < 2) { salida.hidden = true; salida.textContent = ''; ultimo = ''; return; }
    // El indice se calcula del desplazamiento y no de la clase `is-active` del tema: asi no
    // depende de que el tema la actualice ni de que exista en la version que se este sirviendo.
    const ancho = lista.clientWidth || 1;
    const i = Math.min(total, Math.max(1, Math.round(lista.scrollLeft / ancho) + 1));
    const texto = i + '/' + total;
    if (texto === ultimo) return;          // no se toca el DOM si no cambio
    ultimo = texto;
    salida.textContent = texto;
    salida.hidden = false;
  }

  const alDeslizar = () => { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } };

  function enganchar() {
    const nueva = document.querySelector('[id^="Slider-Gallery-"]');
    if (nueva === lista) return;
    if (lista) lista.removeEventListener('scroll', alDeslizar);
    lista = nueva;
    ultimo = '';
    if (!lista) { salida.hidden = true; return; }
    lista.addEventListener('scroll', alDeslizar, { passive: true });
    pintar();
  }

  enganchar();

  // Al cambiar de color, el tema reemplaza el <media-gallery> entero. Se vigila la envoltura,
  // que es UN nodo y cambia poco, en vez de la lista de fotos.
  const envoltura = document.querySelector('.product__media-wrapper');
  if (envoltura && 'MutationObserver' in window) {
    new MutationObserver(() => enganchar()).observe(envoltura, { childList: true, subtree: true });
  }
  window.addEventListener('resize', () => { ultimo = ''; pintar(); }, { passive: true });

  /* --------------------------------------------- subir a la foto al cambiar de color
   * 🔑 POR QUE HACE FALTA, medido en el tema: el unico desplazamiento que existia hoy era un
   * efecto colateral de `media-gallery.js` -> `setActiveMedia()`, y solo dispara si se cumplen
   * DOS condiciones a la vez:
   *     · que la foto de la variante YA este dibujada (`if (!activeMedia) return`), y
   *     · que la galeria NO tenga tira de miniaturas (`!this.elements.thumbnails`),
   *       que el tema solo dibuja cuando el color tiene mas de una foto.
   * De ahi que "Verde pistacho" subiera y "Vinotinto" no: no es el color, es cuantas fotos
   * tiene y si la galeria ya se habia reemplazado. Ademas, cuando el color cambia la galeria
   * entera, el tema llama a `setActiveMedia(..., false)` justamente para NO desplazar.
   * Asi que aca no se toca el tema: se sube uno mismo, siempre y en movil.
   */
  const galeriaWrap = document.querySelector('.product__media-wrapper');
  let tiempoSubir = null;
  function subirALaFoto() {
    if (!galeriaWrap) return;
    let arriba = galeriaWrap.getBoundingClientRect().top + window.scrollY;
    // Medido: al volver arriba el encabezado se revela y ocupa 64 px, asi que la foto queda en
    // 64 y no en 0. Si la galeria es lo primero de la pagina se va directo al tope: alli el
    // propio tema vuelve a esconder el encabezado y la foto queda a sangre, como al abrir.
    if (arriba < 120) arriba = 0;
    // Si ya se esta viendo la foto, no se mueve nada: un desplazamiento de 10 px es un tiron.
    if (Math.abs(window.scrollY - arriba) < 24) return;
    window.scrollTo({ top: arriba, behavior: 'smooth' });
  }
  // Se engancha al `change` del selector de variantes, no a un clic cualquiera: es el evento
  // que el propio tema escucha para recargar la galeria.
  document.addEventListener('change', e => {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('variant-radios, variant-selects, .product-form__input')) return;
    clearTimeout(tiempoSubir);
    // 260 ms: lo justo para que el tema haya empezado a reemplazar la galeria, sin que se note
    // como retraso. No se espera a que llegue la foto nueva: el alto de la galeria no cambia.
    tiempoSubir = setTimeout(subirALaFoto, 260);
  }, true);

  /* ------------------------------------------------------- disponibilidad
   * El TEXTO ya viene calculado del servidor, uno por variante. Aca solo se elige cuál mostrar.
   * 🔴 A proposito: si el stock real viajara al navegador para redondearlo aca, el numero
   * estaria igual en el HTML y la regla de Camilo es no revelarlo cuando es alto.
   */
  const salidaDisp = document.querySelector('[data-ct-disponibilidad]');
  const fuenteDisp = document.querySelector('[data-ct-disponibilidad-mapa]');
  if (salidaDisp && fuenteDisp) {
    let mapa = null;
    try { mapa = JSON.parse(fuenteDisp.textContent); } catch (e) { mapa = null; }

    const idVariante = () => {
      // Misma fuente que usa assets/product-price.js: el input oculto del formulario de compra.
      const el = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return el && el.value ? String(el.value) : null;
    };

    let ultimoTexto = salidaDisp.textContent;
    function pintarDisp() {
      if (!mapa) return;
      const id = idVariante();
      const txt = (id && Object.prototype.hasOwnProperty.call(mapa, id)) ? mapa[id] : '';
      if (txt === ultimoTexto) return;   // no se toca el DOM si no cambio
      ultimoTexto = txt;
      salidaDisp.textContent = txt;
      salidaDisp.hidden = !txt;
    }
    salidaDisp.hidden = !ultimoTexto;

    // Se escucha igual que product-price.js: cualquier cambio o clic en la ficha, con un
    // respiro para que el tema termine de actualizar el input oculto.
    let esperando = null;
    const alCambiar = () => { clearTimeout(esperando); esperando = setTimeout(pintarDisp, 120); };
    document.addEventListener('change', alCambiar, true);
    document.addEventListener('click', alCambiar, true);
    pintarDisp();
  }
})();
